const StorePublicNotice = `
    general_info.store_pa,           store_pa,        true;
    general_info.store_pn,           store_pn;
`;
export default StorePublicNotice;
